function isDocx(mimeType: string) {
  return [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
  ].includes(mimeType);
}

function isPdf(mimeType: string) {
  return ["application/pdf"].includes(mimeType);
}

function isPpt(mimeType: string) {
  return [
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.template",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/vnd.ms-powerpoint.addin.macroEnabled.12",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
    "application/vnd.ms-powerpoint.template.macroEnabled.12",
    "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  ].includes(mimeType);
}

function isExcel(mimeType: string) {
  return [
    "application/vnd.ms-excel",
    "application/vnd.ms-excel",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-excel.template.macroEnabled.12",
    "application/vnd.ms-excel.addin.macroEnabled.12",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  ].includes(mimeType);
}

function isZip(mimeType: string) {
  return [
    "application/zip",
    "application/x-rar-compressed",
    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip",
    "application/x-bzip2",
    "application/x-xz",
    "application/x-lzip",
    "application/zstd",
    "application/gzip",
    "application/x-gzip",
    "application/x-bzip2",
    "application/bzip2",
    "application/x-xz",
    "application/x-xz-compressed",
    "application/x-lzip",
    "application/lzip",
    "application/zstd",
    "application/zstandard",
    "application/lha",
    "application/x-lha",
    "application/x-stuffit",
    "application/x-compactpro",
    "application/x-aix-toolbox",
  ].includes(mimeType);
}

function getFileType(mimeType: string): string {
  if (isDocx(mimeType)) {
    return "docx";
  }
  if (isExcel(mimeType)) {
    return "xlsx";
  }
  if (isPpt(mimeType)) {
    return "pptx";
  }
  return "pdf";
}

function getDocumentType(
  mimeType: string,
): "word" | "cell" | "slide" | undefined {
  if (isDocx(mimeType) || isPdf(mimeType)) {
    return "word";
  }
  if (isExcel(mimeType)) {
    return "cell";
  }
  if (isPpt(mimeType)) {
    return "slide";
  }
  return undefined;
}

export { getDocumentType, getFileType, isExcel, isDocx, isPpt, isZip, isPdf };
